<template>
	<section class="page">
		<div class="content-box">
			<div class="operator">
				<div class="operator-col">
					<el-button size="mini" type="primary" @click="handleCreate()" v-loading="loadings.create">新建</el-button>
				</div>
			</div>
			<curd-table
				ref="listTable"
				:data-model="editorDataModel"
				:fields="tableFields"
				@doedit="handleEdit($event)"
			></curd-table>
		</div>

		<editor
			:show.sync="editorVisible"
			:data-model-name="editorDataModel"
			:record-id="editorId"
			:fields="editorFields"
			@change="refreshTable('listTable')"
			:watches="[{ watch: 'classify', to: 'models' }]"
			v-if="editorVisible"
		></editor>
	</section>
</template>

<script>
import CurdPage from "@/mixins/CurdPage.js";

export default {
	mixins: [CurdPage],

	data() {
		return {
			editorDataModel: "Model_preset",
			editorId: "",
			tableFields: [
				{
					name: "name",
					sortable: "custom",
				},
				{
					name: "models",
				},
			],
			editorFields: [
				{
					name: "name",
					rules: ["required"],
					width: "100%",
				},
				{
					name: "models",
				},
			],
		};
	},
};
</script>
<style lang="scss" scoped>
</style>
